import React from "react";
import "./Testimonials.css";

import flIcon from "../../Images/Icons/fl.png";
import txIcon from "../../Images/Icons/tx.png";
import ncIcon from "../../Images/Icons/nc.png";
import ohIcon from "../../Images/Icons/oh.png";
import nvIcon from "../../Images/Icons/nv.png";

const testimonials = [
  {
    quote:
      "MedaHealth took the time to really listen to what I needed. I felt truly heard.",
    name: "Emily R.",
    location: "Orlando, FL",
    icon: flIcon,
  },
  {
    quote:
      "I saved over $400 this year. They explained every step and made it painless.",
    name: "David P.",
    location: "Austin, TX",
    icon: txIcon,
  },
  {
    quote:
      "No pressure. Just honest advice and support. I trust MedaHealth completely.",
    name: "Linda S.",
    location: "Charlotte, NC",
    icon: ncIcon,
  },
  {
    quote:
      "Fast, friendly, and easy to understand. Best experience I’ve had with insurance.",
    name: "Sophia M.",
    location: "Cleveland, OH",
    icon: ohIcon,
  },
  {
    quote:
      "They helped me compare plans for my entire family. I feel protected and prepared.",
    name: "James T.",
    location: "Reno, NV",
    icon: nvIcon,
  },
];

function Testimonials() {
  return (
    <section className="testimonial-strip">
      <h2 className="testimonial-heading">What Our Clients Say</h2>
      <div className="quote-strip">
        {testimonials.map((t, i) => (
          <blockquote
            className={`quote-block ${
              i % 2 === 0 ? "align-left" : "align-right"
            }`}
            key={i}
          >
            <p className="quote-text">“{t.quote}”</p>
            <footer className="quote-footer">
              <img src={t.icon} alt="state icon" className="state-icon" />
              <span>
                — {t.name}, {t.location}
              </span>
            </footer>
          </blockquote>
        ))}
      </div>
    </section>
  );
}

export default Testimonials;
